// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2_DyC","label":"Category_label__3eLnt","content":"Category_content__12OQL","header":"Category_header__3foij","location":"Category_location__2N_TX"};